<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12">
                <v-card>
                    <v-tabs v-model="tab" color="primary" bg-color="grey-lighten-3">
                        <v-tab v-for="(row, index) in tabList" :key="index" class="font-weight-bold">
                            {{ $t(row.kontoTypCode) }}
                        </v-tab>
                    </v-tabs>

                    <v-window v-model="tab">
                        <v-window-item v-for="(row, index) in tabList" :key="index">
                            <v-card flat>
                                <v-card-text class="pb-0">
                                    <v-row>
                                        <v-col class="pb-0" cols="12">{{ $t('kontobrowser.kontonummer') + '  ' + row.kontoNummer }}</v-col>
                                        <v-col v-if="row.saldoVorschau !== null" class="pt-2 pb-0" cols="12">{{ $t('kontobrowser.saldovorschau') }} </v-col>
                                        <v-col
                                            v-if="row.saldoVorschau !== null && row.saldoVorschau.toString().charAt(0) !== '-'"
                                            cols="12"
                                            class="py-0 text-h4"
                                        >
                                            {{ commafy(row.saldoVorschau.toFixed(2)) }}
                                        </v-col>
                                        <v-col v-else-if="row.saldoVorschau !== null" cols="12" class="py-0 text-h4 text-red">
                                            {{ commafy(row.saldoVorschau.toFixed(2)) }}
                                        </v-col>
                                        <v-col class="pt-2 pb-0" cols="12"
                                            >{{ $t('kontobrowser.saldoletzterfak') + '\n' }}
                                            <br />
                                            {{ '(' + row.kontoSaldoDatum + '):' }}</v-col
                                        >
                                        <v-col v-if="row.kontoSaldo.toString().charAt(0) !== '-'" cols="12" class="pt-0 text-h4">
                                            {{ commafy(row.kontoSaldo.toFixed(2)) }}</v-col
                                        >
                                        <v-col v-else cols="12" class="pt-0 text-h4 text-red"> {{ commafy(row.kontoSaldo.toFixed(2)) }}</v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-divider class="fat-divider my-3" />
                            <v-card flat>
                                <v-card-text>
                                    <v-row>
                                        <v-col sm="12">
                                            <v-row>
                                                <v-col class="pa-0 elevation-1">
                                                    <v-data-table-server
                                                        v-model:sort-by="sortBy"
                                                        :headers="headers"
                                                        :items="tableList"
                                                        item-value="id"
                                                        hide-default-footer
                                                        :items-length="totalNumberOfRecords || 0"
                                                        :header-props="{ class: 'no-border-table ' }"
                                                        :sort-by="['key', 'buchungDatum']"
                                                        :must-sort="true"
                                                        :custom-sort="customSort"
                                                        hover
                                                        @update:sort-by="onSortByChanged"
                                                    >
                                                        <template #top>
                                                            <TableHeader :filters="filters" @chip-closed="removeFilter">
                                                                <template #default>
                                                                    <v-text-field
                                                                        v-if="showSearchBar"
                                                                        v-model="filterData.suchText"
                                                                        class="ml-5"
                                                                        prepend-inner-icon="mdi-magnify"
                                                                        append-inner-icon="mdi-close"
                                                                        :label="$t('kontobrowser.suchfeld')"
                                                                        hide-details
                                                                        autofocus
                                                                        @update:model-value="searchFieldInputChanged"
                                                                        @click:append-inner="searchBarClosed"
                                                                    ></v-text-field>
                                                                    <v-spacer />
                                                                    <v-tooltip top color="secondary">
                                                                        <template #activator="{ props }">
                                                                            <v-btn v-bind="props" icon color="primary">
                                                                                <v-icon v-if="!showSearchBar" @click="showSearchBar = !showSearchBar"
                                                                                    >mdi-magnify</v-icon
                                                                                >
                                                                            </v-btn>
                                                                        </template>
                                                                        <div>
                                                                            <span>
                                                                                {{ $t('tableheader.tooltip.search') }}
                                                                            </span>
                                                                        </div>
                                                                    </v-tooltip>
                                                                    <v-tooltip top color="secondary">
                                                                        <template #activator="{ props }">
                                                                            <v-btn
                                                                                v-bind="props"
                                                                                icon
                                                                                color="primary"
                                                                                @click="showFilterDrawer = !showFilterDrawer"
                                                                            >
                                                                                <v-icon>mdi-filter-outline</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <div>
                                                                            <span>
                                                                                {{ $t('tableheader.tooltip.filter') }}
                                                                            </span>
                                                                        </div>
                                                                    </v-tooltip>
                                                                </template>
                                                            </TableHeader>
                                                        </template>
                                                        <template #item.buchungBetrag="{ item }">
                                                            <span v-if="item.buchungTypCode === 'Soll'" class="text-red"
                                                                >-{{ commafy(item.buchungBetrag.toFixed(2)) }}</span
                                                            >
                                                            <span v-else>{{ commafy(item.buchungBetrag.toFixed(2)) }}</span>
                                                        </template>
                                                        <template #item.buchungText="{ item }">
                                                            <a v-if="item.dokumentGuid !== null" style="text-decoration: underline; cursor: pointer">
                                                                <TextHighlights
                                                                    :text="item.buchungText"
                                                                    :search-text="filterData.suchText"
                                                                    @click="openRechnung(item.dokumentGuid)"
                                                                />
                                                            </a>
                                                            <TextHighlights v-else :text="item.buchungText" :search-text="filterData.suchText" />
                                                        </template>
                                                        <template #item.kontoSaldo="{ item }">
                                                            <span v-if="item.kontoSaldo < 0" class="text-red">{{ commafy(item.kontoSaldo.toFixed(2)) }}</span>
                                                            <span v-else>{{ commafy(item.kontoSaldo.toFixed(2)) }}</span>
                                                        </template>
                                                        <template #item.link="{ item }">
                                                            <v-tooltip location="left" color="secondary">
                                                                <template #activator="{ props }">
                                                                    <v-btn
                                                                        v-if="item.dokumentGuid !== null"
                                                                        v-bind="props"
                                                                        icon
                                                                        flat
                                                                        :href="item.link"
                                                                        @click="
                                                                            download({
                                                                                id: item.dokumentGuid,
                                                                                dokumentName: item.dokumentName
                                                                            })
                                                                        "
                                                                    >
                                                                        <v-icon color="primary" icon="mdi-file-pdf" />
                                                                    </v-btn>
                                                                </template>
                                                                <div>
                                                                    <!-- eslint-disable vue/no-v-html -->
                                                                    <p v-html="$t('kontobrowser.tooltip.download.pdf')" />
                                                                </div>
                                                            </v-tooltip>
                                                        </template>
                                                        <template #item.csv="{ item }">
                                                            <v-tooltip location="left" color="secondary">
                                                                <template #activator="{ props }">
                                                                    <v-btn
                                                                        v-if="item.monatJournalGuid"
                                                                        v-bind="props"
                                                                        icon
                                                                        flat
                                                                        @click="
                                                                            downloadMonatJournalCsv({
                                                                                id: item.monatJournalGuid
                                                                            })
                                                                        "
                                                                    >
                                                                        <v-icon color="primary" icon="mdi-file-delimited" />
                                                                    </v-btn>
                                                                </template>
                                                                <div>
                                                                    <!-- eslint-disable vue/no-v-html -->
                                                                    <p v-html="$t('kontobrowser.tooltip.download.csv')" />
                                                                </div>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-data-table-server>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-window-item>
                    </v-window>
                </v-card>
            </v-col>
        </v-row>
        <Form v-slot="{ meta }">
            <FilterDrawer
                v-model:visible="showFilterDrawer"
                :closeable="!meta.valid"
                @cancel="cancelFilter()"
                @confirm="confirmFilter()"
                @clear="clearAllFilters(true)"
                @reset="clearAllFilters(false)"
            >
                <SingleFilter title="">
                    <template #default>
                        <div>
                            <div>
                                <v-radio-group v-model="radios" class="mt-0" inline>
                                    <h5 class="pb-0">{{ $t('archiv.filter.title.datum') }}</h5>
                                    <v-col cols="12">
                                        <v-radio value="specificTime" :label="$t('kontobrowser.filter.specifictime')"></v-radio>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                        <v-row>
                                            <v-col cols="6">
                                                <NowhowDatepicker
                                                    v-model="filterData.buchungDatumVon"
                                                    :disabled="radios !== 'specificTime'"
                                                    label="archiv.filter.datum.von"
                                                    @change="onBuchungsDatumVonChange"
                                                >
                                                </NowhowDatepicker>
                                            </v-col>
                                            <v-col cols="6">
                                                <NowhowDatepicker
                                                    v-model="filterData.buchungDatumBis"
                                                    :disabled="radios !== 'specificTime'"
                                                    label="archiv.filter.datum.bis"
                                                    @change="onBuchungsDatumBisChange"
                                                >
                                                </NowhowDatepicker>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                        <v-radio value="selectTime" :label="$t('kontobrowser.filter.selecttime')"></v-radio>
                                    </v-col>
                                    <v-col cols="12" class="pt-0 pb-8">
                                        <v-select
                                            v-model="filterData.zeitspanne"
                                            :disabled="radios !== 'selectTime'"
                                            variant="filled"
                                            density="compact"
                                            hide-details
                                            :items="ddTimeItems"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" class="pt-0 pb-0">
                                        <v-radio value="allTime" :label="$t('kontobrowser.filter.alltime')"></v-radio>
                                    </v-col>
                                </v-radio-group>
                            </div>
                            <div>
                                <h5 class="pb-2">
                                    {{ $t('kontobrowser.filter.title.betrag') }}
                                </h5>
                                <v-row class="pb-6 filterLine">
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="filterData.betragVon"
                                            hide-details
                                            variant="filled"
                                            density="compact"
                                            :label="$t('archiv.filter.datum.von')"
                                            @keypress="checkInputCharacter($event)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="filterData.betragBis"
                                            hide-details
                                            variant="filled"
                                            density="compact"
                                            :label="$t('archiv.filter.datum.bis')"
                                            @keypress="checkInputCharacter($event)"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </template>
                </SingleFilter>
            </FilterDrawer>
        </Form>
    </v-container>
</template>

<script lang="ts">
import { Component, Watch, mixins } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import debounce from 'lodash/debounce';
import { DateMixin } from '@/mixins/DateMixin';

import { NAME as NAME_HOME } from '../store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';
import { NAME as NAME_RESOURCE } from '@/store/modules/resource';

const homeModul = namespace(NAME_HOME);
const generalModul = namespace(NAME_GENERAL);
const securityModul = namespace(NAME_SECURITY);
const headerModul = namespace(NAME_HEADERNOTIFICATION);
const resourceModul = namespace(NAME_RESOURCE);

import { HomeFilterDto } from '@/types/HomeFilterDto';

import { GET_LANGUAGE } from '@/store/modules/resource/getters';
import { LOAD_VALUES, LOAD_TAB, DOWNLOAD_RECHNUNG, OPEN_RECHNUNG, DOWNLOAD_MONATJOURNAL_CSV } from '../store/actions';
import { APPLYFILTER, CLEARFILTER } from '../store/mutations';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import { TABLEVALUES, TABVALUES, TOTAL_NUMBER_OF_RECORDS, LOADING } from '../store/getters';
import { HASACCESS } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';

import { ZeitspanneFilterApiDto, KontoSaldoApiDto, TvsBuchungApiDto } from '@/api-schema';

import { Form, Field } from 'vee-validate';
import NowhowDatepicker from '@/components/NowhowDatepicker.vue';
import SingleFilter from '@/components/SingleFilter.vue';
import FilterDrawer from '@/components/FilterDrawer.vue';
import TableHeader from '@/components/TableHeader.vue';
import TextHighlights from '@/components/TextHighlight/TextHighlights.vue';
import { TableHeaderFilterItem } from '@/types/TableHeaderFilterItem';

@Component({
    components: {
        SingleFilter,
        FilterDrawer,
        TableHeader,
        NowhowDatepicker,
        Form,
        Field,
        TextHighlights
    }
})
export default class Home extends mixins(DateMixin) {
    filters: Array<TableHeaderFilterItem> = [];
    private expanded = [];
    private showFilterDrawer = false;
    private showSearchBar = false;
    private tab = null;
    private radios = 'selectTime';
    private radiosCopy = '';
    sortBy: [{ key: 'rechnungDatum'; order: 'desc' }];
    filterData: HomeFilterDto = new HomeFilterDto();
    filterDataCopy: HomeFilterDto = new HomeFilterDto();
    get ddTimeItems(): Array<object> {
        return [
            {
                title: this.$t('kontobrowser.filter.timeitems.letztezeit'),
                value: 'Last60Days' as ZeitspanneFilterApiDto
            },
            {
                title: this.$t('kontobrowser.filter.timeitems.aktuelljahr'),
                value: 'CurrentYear' as ZeitspanneFilterApiDto
            },
            {
                title: this.$t('kontobrowser.filter.timeitems.vorjahr'),
                value: 'LastYear' as ZeitspanneFilterApiDto
            }
        ];
    }
    get headers(): Array<any> {
        return [
            {
                title: this.$t('kontobrowser.table.datum'), // Changed from text -> title
                key: 'buchungDatum' // Changed from value -> key
            },
            {
                title: this.$t('kontobrowser.table.Kontobewegung'),
                key: 'buchungText'
            },
            {
                title: this.$t('kontobrowser.table.betrag'),
                key: 'buchungBetrag',
                align: 'end',
                sortable: false
            },
            {
                title: this.$t('kontobrowser.table.saldo'),
                key: 'kontoSaldo',
                align: 'end',
                sortable: false
            },
            {
                title: '',
                key: 'link',
                align: 'left',
                width: '50',
                sortable: false
            },
            {
                title: '',
                key: 'csv',
                width: '50',
                align: 'center',
                sortable: false
            }
        ];
    }

    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;

    @homeModul.Action(LOAD_VALUES) load!: Function;
    @homeModul.Action(LOAD_TAB) getTabs!: Function;
    @homeModul.Action(DOWNLOAD_RECHNUNG) download!: Function;
    @homeModul.Action(DOWNLOAD_MONATJOURNAL_CSV) downloadMonatJournalCsv!: Function;
    @homeModul.Action(OPEN_RECHNUNG) openRechnung!: Function;
    @homeModul.Mutation(APPLYFILTER) applyFilters!: Function;
    @homeModul.Mutation(CLEARFILTER) clearFilter!: Function;
    @homeModul.Getter(TABLEVALUES) tableList!: Array<TvsBuchungApiDto>;
    @homeModul.Getter(TABVALUES) tabList!: Array<KontoSaldoApiDto>;
    @homeModul.Getter(LOADING) loading!: boolean;
    @homeModul.Getter(TOTAL_NUMBER_OF_RECORDS) totalNumberOfRecords!: number | null;

    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
    @resourceModul.Getter(GET_LANGUAGE) language!: string;

    @headerModul.Action(NEW_ALERT) alertMessage!: Function;

    created() {
        this.checkRedirectNeeded();
        if (this.hasAccess('Navigation.Kontobrowser')) {
            this.setAccessDenied(false);
            this.loadTabsAndProceed();
            this.setSubTitle(this.$t('kontobrowser.subtitle'));
            this.setFooterTitle('S200');
        }
    }

    mounted() {
        if (this.hasAccess('Navigation.Kontobrowser')) {
            this.filterData.zeitspanne = 'Last60Days';
            this.filters.push({
                key: 'archiv.filter.chip.title.datum',
                nameResourceKey: 'archiv.filter.chip.title.datum',
                value: this.$t('kontobrowser.filter.timeitems.letztezeit').toString()
            });
            this.applyFilters(this.filterData);
        } else {
            console.log('Waiting for permissions.');
        }

        this.searchFieldInputChanged = debounce(() => {
            this.applyFilters(this.filterData);
            this.load(0);
        }, 400);
    }

    /* Funktion deklarieren, aber erst in mount mit debounce initialisieren */
    searchFieldInputChanged!: () => void;

    async loadTabsAndProceed() {
        await this.getTabs(); // Ensures getTabs is completed before proceeding
        if (this.tab == null) {
            this.tab = 0;
        }
    }

    private ShowActiveFilters() {
        this.filters = [];
        if (this.radios === 'allTime') {
            this.filterData.buchungDatumVon = undefined;
            this.filterData.buchungDatumBis = undefined;
            this.filterData.zeitspanne = undefined;
        }
        if (this.radios === 'specificTime') {
            this.filterData.zeitspanne = undefined;
            let filterValue = '';
            if (this.filterData.buchungDatumVon && this.filterData.buchungDatumBis) {
                filterValue = this.filterData.buchungDatumVon + ' - ' + this.filterData.buchungDatumBis;
            } else if (this.filterData.buchungDatumVon) {
                filterValue = '<= ' + this.filterData.buchungDatumVon;
            } else if (this.filterData.buchungDatumBis) {
                filterValue = '>= ' + this.filterData.buchungDatumBis;
            }

            this.filters = this.filters.concat({
                key: 'archiv.filter.chip.title.datum',
                nameResourceKey: 'archiv.filter.chip.title.datum',
                value: filterValue
            });
        }
        if (this.radios === 'selectTime') {
            this.filterData.buchungDatumVon = undefined;
            this.filterData.buchungDatumBis = undefined;
            if (this.filterData.zeitspanne === 'Last60Days') {
                this.filters = this.filters.concat({
                    key: 'archiv.filter.chip.title.datum',
                    nameResourceKey: 'archiv.filter.chip.title.datum',
                    value: this.$t('kontobrowser.filter.timeitems.letztezeit').toString()
                });
            } else if (this.filterData.zeitspanne === 'CurrentYear') {
                this.filters = this.filters.concat({
                    key: 'archiv.filter.chip.title.datum',
                    nameResourceKey: 'archiv.filter.chip.title.datum',
                    value: this.$t('kontobrowser.filter.timeitems.aktuelljahr').toString()
                });
            } else if (this.filterData.zeitspanne === 'LastYear') {
                this.filters = this.filters.concat({
                    key: 'archiv.filter.chip.title.datum',
                    nameResourceKey: 'archiv.filter.chip.title.datum',
                    value: this.$t('kontobrowser.filter.timeitems.vorjahr').toString()
                });
            }
        }
        if (this.filterData.betragVon !== undefined && this.filterData.betragBis) {
            this.filters = this.filters.concat({
                key: 'kontobrowser.chip.betrag',
                nameResourceKey: 'kontobrowser.chip.betrag',
                value: this.filterData.betragVon + ' - ' + this.filterData.betragBis
            });
        }
    }

    private removeFilter(value: string) {
        this.filters = this.filters.filter(function (obj) {
            return obj.key !== value;
        });
        if (value === 'archiv.filter.chip.title.datum') {
            this.filterData.buchungDatumVon = undefined;
            this.filterData.buchungDatumBis = undefined;
            this.filterData.zeitspanne = undefined;
            this.radios = 'allTime';
        } else if (value === 'kontobrowser.chip.betrag') {
            this.filterData.betragVon = undefined;
            this.filterData.betragBis = undefined;
        }
        this.applyFilters(this.filterData);
        this.load(0);
    }

    private searchBarClosed() {
        this.showSearchBar = false;
        this.filterData.suchText = undefined;
        this.applyFilters(this.filterData);
        this.load(0);
    }

    private clearAllFilters(closeFilter: boolean) {
        this.radios = 'selectTime';
        this.filterData = new HomeFilterDto();
        this.filterData.buchungDatumVon = undefined;
        this.filterData.buchungDatumBis = undefined;
        this.filterData.zeitspanne = 'Last60Days';
        this.filterData.tvsKontoNummer = this.tabList[this.tab].kontoNummer.toString();
        if (closeFilter) {
            this.filters = [];
            this.clearFilter();
            this.applyFilters(this.filterData);
            this.showFilterDrawer = false;
        }
    }

    commafy(num: number) {
        const isNegativ = num.toString().charAt(0) === '-';
        const str = num.toString().split('.');
        if (isNegativ) {
            str[0] = str[0].slice(1, str[0].length);
        }
        for (let i = 3; i < str[0].length; i += 4) {
            str[0] = str[0].slice(0, str[0].length - i) + "'" + str[0].slice(str[0].length - i, str[0].length);
        }
        if (isNegativ) {
            return '-' + str.join('.');
        } else {
            return str.join('.');
        }
    }

    private customSort(items: any[]) {
        return items;
    }

    checkInputCharacter(evt: any) {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    }

    private checkRedirectNeeded() {
        if (this.hasAccess('Navigation.Kontobrowser')) {
            return true;
        } else if (this.hasAccess('Navigation.Lieferantenrechnung')) {
            this.$router.push({ name: 'Lieferantenrechnungen' });
        } else if (this.hasAccess('Navigation.Dokumentarchiv')) {
            this.$router.push({ name: 'Dokumentarchiv' });
        } else if (this.hasAccess('Navigation.TakeTeilnehmer')) {
            this.$router.push({ name: 'TakeTeilnehmer' });
        } else if (this.hasAccess('Navigation.PraxisgruppeRechnungen')) {
            this.$router.push({ name: 'PraxisgruppeRechnungen' });
        } else if (this.hasAccess('Navigation.TreuhandTeilnehmerListe')) {
            this.$router.push({ name: 'TreuhandTeilnehmerListe' });
        } else if (this.hasAccess('Navigation.LieferantRechnungen')) {
            this.$router.push({ name: 'LieferantRechnungen' });
        }
    }

    private confirmFilter() {
        this.ShowActiveFilters();
        this.applyFilters(this.filterData);
        this.load(0);
        this.showFilterDrawer = false;
    }

    private cancelFilter() {
        this.filterData = Object.assign({}, this.filterDataCopy);
        this.radios = this.radiosCopy;
        this.showFilterDrawer = false;
    }

    onSortByChanged(newSortBy: any) {
        this.sortBy = newSortBy;
        if (this.sortBy.length > 0) {
            const sortField = this.sortBy[0]; // { key: 'lieferantName', order: 'desc' }

            this.filterData.sortBy = sortField.key.charAt(0).toUpperCase() + sortField.key.slice(1);
            this.filterData.sortOrder = sortField.order === 'desc' ? 'Descending' : 'Ascending';
        } else {
            this.filterData.sortBy = null;
            this.filterData.sortOrder = null;
        }

        this.applyFilters(this.filterData);
        this.load(0);
    }

    @Watch('showFilterDrawer')
    onFilterDrawerOpened() {
        if (this.showFilterDrawer) {
            this.filterDataCopy = Object.assign({}, this.filterData);
            this.radiosCopy = this.radios;
        }
    }

    @Watch('tab')
    onTabChanged() {
        this.filters = [];
        this.clearAllFilters(true);
        this.filterData.tvsKontoNummer = this.tabList[this.tab].kontoNummer.toString();
        this.ShowActiveFilters();
        this.applyFilters(this.filterData);
        this.load(0);
    }

    @Watch('language')
    onLanguageChanged() {
        this.ShowActiveFilters();
    }
    onBuchungsDatumVonChange(newValue: string) {
        if (newValue) {
            this.filterData.buchungDatumVon = newValue;
        }
    }
    onBuchungsDatumBisChange(newValue: string) {
        if (newValue) {
            this.filterData.buchungDatumBis = newValue;
        }
    }
}
</script>
